export function clearPersistentToken() {
    window.localStorage.removeItem('ptoken');
    window.localStorage.removeItem('ptoken_expiry');
}

export function shouldSendAuthCookie(config) {
    const url = config?.url || '';
    return url.includes('/adminapi/Login') || url.includes('/adminapi/outLogin');
}
